import { BatchPan, IncompletePan } from '../types/batchPan';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003/api';

export const batchPanApiService = {
  /**
   * Fetch all incomplete pans (for workflow In Progress section)
   */
  fetchIncompletePans: async (): Promise<IncompletePan[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-pans/incomplete`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch incomplete pans');
      }

      return data.pans;
    } catch (error) {
      console.error('Error fetching incomplete pans:', error);
      throw error;
    }
  },

  /**
   * Fetch all pans for a batch record (for batch record page)
   */
  fetchPansByBatchRecord: async (batchRecordId: string): Promise<BatchPan[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-records/${batchRecordId}/pans`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch pans for batch record');
      }

      return data.pans;
    } catch (error) {
      console.error('Error fetching pans for batch record:', error);
      throw error;
    }
  },

  /**
   * Create a new pan for a batch record
   */
  createPan: async (batchRecordId: string): Promise<BatchPan> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-records/${batchRecordId}/pans`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to create pan');
      }

      return data.pan;
    } catch (error) {
      console.error('Error creating pan:', error);
      throw error;
    }
  },

  /**
   * Update a pan's processing data
   */
  updatePan: async (panId: string, panData: Partial<BatchPan>): Promise<BatchPan> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-pans/${panId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(panData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to update pan');
      }

      return data.pan;
    } catch (error) {
      console.error('Error updating pan:', error);
      throw error;
    }
  },

  /**
   * Delete a pan
   */
  deletePan: async (panId: string): Promise<void> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-pans/${panId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || 'Failed to delete pan');
      }
    } catch (error) {
      console.error('Error deleting pan:', error);
      throw error;
    }
  }
};
